import { render, staticRenderFns } from "./OrchestrationSettings.vue?vue&type=template&id=331340a1"
import script from "./OrchestrationSettings.vue?vue&type=script&lang=js"
export * from "./OrchestrationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports